import { FieldType, Model, Schema } from "@core/index";
import { CabinClass } from "./AvailabilityRequest";

export interface IOriginDestinationRequest {
    id?: number;
    classOfService?: CabinClass;
    jsessionId?: string;
    originCode?: string;
    destinationCode?: string;
    departureDate?: number;
    arrivalDate?: number;
    daysBefore?: number;
    daysAfter?: number;
    selectedSegmentRph?: string;
    selected?: boolean;
}

export class OriginDestionationRequest extends Model implements IOriginDestinationRequest {
    public static schema: Schema = new Schema("OriginDestionationRequest");
    public id?: number;
    public classOfService?: CabinClass;
    public originCode?: string;
    public destinationCode?: string;
    public departureDate?: number;
    public daysBefore?: number;
    public daysAfter?: number;
    public selected?: boolean;


    constructor(values: IOriginDestinationRequest) {
        super(OriginDestionationRequest.schema);
        this.setValues(values);
    }
}

OriginDestionationRequest.schema.addField("id").type(FieldType.Integer).primary();
OriginDestionationRequest.schema.addField("originCode").type(FieldType.String).required();
OriginDestionationRequest.schema.addField("destinationCode").type(FieldType.String).required();
OriginDestionationRequest.schema.addField("departureDate").type(FieldType.Timestamp).required();
OriginDestionationRequest.schema.addField("daysBefore").type(FieldType.Integer).required();
OriginDestionationRequest.schema.addField("daysAfter").type(FieldType.Integer).required();
OriginDestionationRequest.schema.addField("classOfService").type(FieldType.Enum).enum(CabinClass.Y, CabinClass.A, CabinClass.C).default(CabinClass.Y).required();

